import React, { Component } from "react";
import { Layout, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { connect } from 'react-redux';
import propTypes from "prop-types";
import { Div } from "./style";
import AuthInfo from "../components/utilities/auth-info/info";
import moment from "moment";
import SidebarMenu from "./SidebarMenu";
import TopMenu from "./TopMenu";
import { changeLayoutMode } from '../redux/themeLayout/actionCreator';

const { darkTheme } = require("../config/theme/themeVariables");
const { Header, Footer, Content } = Layout;

const ThemeLayout = (WrappedComponent) => {

    class LayoutComponent extends Component {
        render() {
            const darkMode = false;
            const xs = window.innerWidth <= 576; // Adjust breakpoint as needed

            return (
                <Div darkMode={darkMode}>
                    <Layout className="layout">
                        <Header>
                            <Row gutter={[16, 16]}>
                                <Col xxl={4} lg={4} md={5} sm={6} xs={7} className='d-flex'>
                                    <div className={"logo"} >
                                        { !xs ? (
                                        <Link  to="/">
                                            <img src={require(`../static/img/logo.png`)} alt="logo" width={'110'} />
                                        </Link>)
                                        : (
                                            <Link  to="/">
                                                <img src={require(`../static/img/logo-icon.png`)} alt="logo" width={'50%'}  />
                                            </Link>
                                         )}
                                        <SidebarMenu />
                                    </div>
                                </Col>
                                <Col xxl={15} lg={15} md={15} sm={10} xs={10} className='d-flex'>
                                    <TopMenu />
                                </Col>
                                <Col xxl={5} lg={5} md={4} sm={8} xs={7}>
                                    <AuthInfo />
                                </Col>
                            </Row>
                        </Header>
                        <Layout>
                            <ThemeProvider theme={darkTheme}>
                                <Layout>
                                    <Content style={{ minHeight: 'calc(100vh - 128px)', width: '100%' }}>
                                        <WrappedComponent {...this.props} />
                                    </Content>
                                </Layout>
                            </ThemeProvider>
                        </Layout>
                        <Footer className="admin-footer" style={{ padding: "20px 30px",textAlign:'right' }}>
                            <span>
                                2018 - {moment().format("YYYY")} © <Link to="https://www.skilledanswers.com/">SkilledAnswers Info Solutions Pvt Ltd</Link>
                            </span>
                        </Footer>
                    </Layout>
                </Div>
            );
        }
    }

    const mapStateToProps = (state) => {
        return {
            ChangeLayoutMode: state.ChangeLayoutMode.data,
        };
    };

    const mapStateToDispatch = (dispatch) => {
        return {
            changeLayout: (show) => dispatch(changeLayoutMode(show)),
        };
    };

    LayoutComponent.propTypes = {
        ChangeLayoutMode: propTypes.bool,
        rtl: propTypes.bool,
        topMenu: propTypes.bool,
        changeRtl: propTypes.func,
        changeMenuMode: propTypes.func,
    };



    return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};

export default ThemeLayout;
